var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.649 2.4002 0.6615-0.67042c0.3196-0.33149 0.33001-0.75367 0.02082-1.0644l-0.19623-0.18582c-0.27947-0.28839-0.71353-0.25865-1.0227 0.052028l-0.67191 0.66002zm-11.039 10.058 1.7556-0.77299 8.6025-8.6025-1.2085-1.1981-8.5921 8.601-0.82502 1.6946c-0.07284 0.1546 0.10406 0.35082 0.26757 0.27798zm7.1873 7.2587c1.7244 0 2.7159-0.99002 2.7159-2.921v-10.761l-1.3527 1.3527v9.3354c0 1.0852-0.58866 1.6411-1.3944 1.6411h-11.348c-1.0539 0-1.6203-0.55745-1.6203-1.6411v-11.089c0-1.0748 0.56637-1.6322 1.6203-1.6322h8.7363l1.3527-1.3527h-10.108c-1.9622 0-2.9552 0.9811-2.9552 2.9225v11.223c0 1.9429 0.99151 2.9225 2.9537 2.9225z",
    fill: "currentColor",
    fillRule: "evenodd",
    strokeWidth: 1.4865
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_edit.02b273381ac9d969381eb6fec7cf182c.svg";